import { render, staticRenderFns } from "./product_selector.vue?vue&type=template&id=7bae58c6"
import script from "./product_selector.vue?vue&type=script&lang=js"
export * from "./product_selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports